export default __webpack_public_path__ + "bfea734067a2e7cbf1d9fd0ccc718739.jpg";